module.exports = __webpack_public_path__ + "static/media/wavm8s-009-waller-subby-n-dubby-mix.9457b3c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-009-waller-subby-n-dubby-mix.mp3
// module id = 6Z23
// module chunks = 0